import { Skeleton } from '@mui/material';

export function ProductInfoSkeleton() {
  return (
    <div className="flex flex-col w-full">
      <Skeleton variant="text" width={60} height={16} />
      <Skeleton variant="text" width={150} height={50} />
      <Skeleton variant="text" width={80} height={24} />
    </div>
  );
}
